import { State } from "../types";

export type RedoAction = Readonly<{
  type: "REDO";
}>;

export const redo = (state: State, _action: RedoAction): State => {
  if (state.cellHistoryIndex >= state.cellHistory.length - 1) {
    return state;
  }
  return {
    ...state,
    cellHistoryIndex: state.cellHistoryIndex + 1,
    cells: state.cellHistory[state.cellHistoryIndex + 1],
  };
};
